import {makeLogger} from '../../logger/logger';

declare global {
  /* eslint no-var: off */
  var KAMPYLE_ONSITE_SDK: {
    [key: string]: Function;
  };

  interface Window {
    surveyType: string;
    surveyLangCountryCode: string;
    surveyLangCode: string;
    surveyBrandType: string;
    genAiPage?: string;
  }
}

const { err } = makeLogger({
  pathToCurrentFile: 'utils/medalia-integration/medalia-integration.ts',
  loggersList: ['err']
});

const loadMedaliaComponent = (
  formId: string,
  configuration: { [key: string]: string },
  formIdKey: string
) => {
    if (!KAMPYLE_ONSITE_SDK) throw new Error('Can not access Medalia global object');

    for (const key in configuration) {
      if (configuration.hasOwnProperty(key)) {
        window[key] = configuration[key];
      }
    }

    KAMPYLE_ONSITE_SDK?.loadForm(formId);
    window[formIdKey] = true;
};

export const showMedaliaComponent = async (
  formId: string,
  configuration: { [key: string]: string },
  failureCallback?: () => any  //eslint-disable-line
) => {
    const formIdKey = `medaliaForm${formId}`;
    const callback = () => (failureCallback ? failureCallback() : void 0);

    try {
      // formIdKey is added to check if medalia was already loaded
      if (!window[formIdKey]) {
        await loadMedaliaComponent(formId, configuration, formIdKey);
      }

      KAMPYLE_ONSITE_SDK?.showForm(formId);
    } catch(e) {
      err(e);
      callback();
    }
};
